import React, {useMemo} from "react";
import classNames from "classnames";
import ARIcon from "../../../../ARIcon";
import {CInputGroup, CInputGroupPrepend, CInputGroupText} from "@coreui/react";
import "./ARControlList.scss";

const ARControlList = (props) => {
  const {className, prependComponent, items, getItemText, emptyText, actionIconProps, onActionIconClick} = props;

  const elements = useMemo(() => {
    return items && (items.map((item) => ({text: getItemText(item).toString(), item})));
  }, [items, getItemText]);

  return (
    <CInputGroup className={classNames(className)}>
      {prependComponent &&
      <CInputGroupPrepend>
        <CInputGroupText className="ARControlList__prepend-text">
          {prependComponent}
        </CInputGroupText>
      </CInputGroupPrepend>
      }
      <div className="form-control ARControlList">
        {elements.length > 0
          ?
          elements.map((element, index) => (
            <div
              key={`${element.text} ${index}`}
              className="ARControlList__elements align-middle"
            >
              <span className="ARControlList__element-text">{element.text}</span>&nbsp;
              <ARIcon
                {...actionIconProps}
                className={`ml-1 ${actionIconProps.className}`}
                onClick={(event) => onActionIconClick({item: element.item, index, event})}
              />
            </div>
          ))
          :
          <div className="ARControlList__empty-text">{emptyText}</div>
        }
      </div>
    </CInputGroup>
  );
};

ARControlList.defaultProps = {
  emptyText: "Empty"
};

export default ARControlList;